<table class="table table-hover">
    <thead>
        <tr id="tr-placeholder-mm">
            <th id="th-placeholder-mm" class="align-left">
                Name <p class="wrap-p align-left">of issuer</p>
            </th>
            <th class="align-left">
                Title of issuer
            </th>
            <th class="align-right">
                Coupon/Yield
            </th>
            <th class="align-left">
                Category of investment
            </th>
            <th class="align-right">
                Cusip/Other id
            </th>
            <th class="align-right">
                <a role="button" tabindex="0" class="secYieldLink dialog-button" (click)="effectiveMaturityContent.openModalDialog();" href="javascript:void(0)">
                    Effective maturity date
                </a>

                <c11n-modal-dialog modalId="effectiveMaturityModal" [headingText]="'Effective maturity date'" #effectiveMaturityContent>
                    <div c11n-modal-dialog-body>
                        <p [innerHTML]="effectiveMaturityDateDefinition?.contentValue"></p>
                    </div>
                </c11n-modal-dialog>

            </th>
            <th class="align-right">
                <a href="javascript:void(0)" role="button" tabindex="0" class="secYieldLink dialog-button" (click)="finalMaturityContent.openModalDialog();">
                    Final maturity date
                </a>

                <c11n-modal-dialog modalId="finalMaturityModal" [headingText]="'Final maturity date'" #finalMaturityContent>
                    <div c11n-modal-dialog-body>
                        <p [innerHTML]="finalMaturityDateDefinition?.contentValue"></p>
                    </div>
                </c11n-modal-dialog>

            </th>
            <th class="align-right">Principal amount
            </th>
            <th class="align-right">Amortized cost
        <tr>
    </thead>
    <tbody>
        <tr *ngFor="let holding of moneyMarketResults?.fund?.entity">
            <th class="align-left">
                —
            </th>
            <td class="align-left">{{holding?.title ? holding?.title : '—'}}
            </td>
            <td class="no-wrap align-right" >
                {{holding.couponRate ? holding.couponRate + ' %' : '—'}}
            </td>
            <td class="align-left">
                {{holding.category ? holding.category : '—'}}
            </td>
            <td class="align-right">
                {{holding?.cusip ? holding?.cusip : '—'}}
            </td>
            <td class="align-right">
                {{holding.effectiveMaturityDate ? (holding.effectiveMaturityDate | ESTPipe) : '—'}}
            </td>
            <td class="align-right">
                {{holding.finalMaturityDate ? (holding.finalMaturityDate | ESTPipe) : '—'}}
            </td>
            <td class="align-right">
                {{holding.principalAmount ?
                (holding.principalAmount | currency : 'USD' : 'symbol' : '1.0-0') : '—' }}
            </td>
            <td class="align-right">
                {{holding.amortizedCost ?
                (holding.amortizedCost | currency : 'USD' : 'symbol' : '1.0-0') : '—' }}
            </td>
        <tr>
    </tbody>
</table>
